import account from './account.vue'

export default account
